module.exports = __webpack_public_path__ + "static/media/19.11c8b100.png";